<template>
  <el-dialog :title="dialogTitle" :visible.sync="showDelappoint" width="700px" :before-close="handleClose">
    <el-form :inline="true" class='longForm'>

      <el-form-item class="item-textarea" v-if='dialogStatus == 10' label="取消原因" label-width="100px">
        <el-input type='textarea' placeholder="请填写取消原因" :rows='3' v-model="reason"></el-input>
      </el-form-item>
      <el-form-item class="item-textarea" v-if='dialogStatus == 1' label="取消原因" label-width="100px">
        <el-input readonly type='textarea' placeholder="未填写取消原因" :rows='3' v-model="cantreason"></el-input>
      </el-form-item>
      <el-form-item class="item-textarea" v-if='dialogStatus == 0' label="审批意见" label-width="100px">
        <el-input readonly type='textarea' placeholder="未填写审批意见" :rows='3' v-model="cantreason"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if='dialogStatus == 10' @click="handleClose">取 消</el-button>
      <el-button v-if='dialogStatus == 10' type="primary" @click="delappoint">确 定</el-button>
      <el-button v-if='dialogStatus != 10' @click="handleClose">返回</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    showDelappoint: {

    },
    dialogTitle: {

    },
    dialogStatus: {

    },
    cantreason: {

    },
    appointId: {

    }
  },
  data() {
    return {
      reason: '',
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    delappoint() {
      let data = {
        deviceReservationRecordId: this.appointId,
        remark: this.reason
      }
      this.$net(`/sdau/deviceReservation/cancelReservation`, 'post', data).then(res => {
        if (res.code == 200) {
          this.$message.success('取消成功')
          this.handleClose()
        } else {
          this.$message.error(res.msg)

        }
      })
    },
  },
  created() {

  }
}
</script>
<style lang="scss" scoped>
.item-textarea {
  .el-textarea {
    width: 500px;
  }
}
</style>